import type { ReactNode } from "react";
import type { IconType } from "../Icon";
import { Icon } from "../Icon";
import { twMerge } from "tailwind-merge";
import { ListItemIconTile } from "../ListItemIconTile";

export const ListItem = ({
  title,
  subtitle,
  className,
  icon,
  iconClassName,
  actionText,
  onClick,
  iconClick,
}: {
  title: string;
  subtitle: ReactNode;
  className?: string;
  icon: IconType;
  iconClassName?: string;
  actionText?: string;
  onClick: () => void;
  iconClick?: () => void;
}) => {
  return (
    <div
      className={twMerge(
        "flex cursor-pointer items-center gap-4 px-6 py-3 hover:bg-zinc-100",
        className,
      )}
      onClick={onClick}
    >
      <ListItemIconTile
        icon={icon}
        className={twMerge(
          "border-2 border-zinc-100 hover:border-zinc-500",
          iconClassName,
        )}
        onClick={(e) => {
          e.stopPropagation();
          iconClick?.();
        }}
      />
      <div className="flex w-full items-center gap-4 md:flex-nowrap">
        <div className="flex flex-col">
          <p className="font-semibold">{title}</p>
          <div className="flex flex-wrap items-center gap-1 text-sm">
            {subtitle}
          </div>
        </div>
        <span className="ml-auto flex flex-none cursor-pointer items-center rounded-lg px-2 py-1">
          {actionText} <Icon icon="CHEVRON_RIGHT" size={1} />
        </span>
      </div>
    </div>
  );
};
